import React from 'react';
import MaterialPill, { ChipProps } from '@mui/material/Chip';

import { cn } from '@lyearn/style';

const BasePill = React.forwardRef<HTMLDivElement, ChipProps>((props, ref) => {
  const { className, label, onClick, ...rest } = props;
  const clickable = !!onClick;
  const clickableClasses = clickable ? 'cursor-pointer' : '';

  return (
    <MaterialPill
      ref={ref}
      className={cn(className, clickableClasses)}
      label={label}
      onClick={onClick}
      {...rest}
    />
  );
});

export default BasePill;
